import useEventEE from '@hooks/useEventEE';

const useAttendeeMode = ({ eventName, eventCode, eventDate }) => {
    const { event } = useEventEE(eventCode);

    return {
        event,
        eventName,
        eventCode,
        eventDate,
        isAttendeeSearch: !!eventCode,
    };
};

export default useAttendeeMode;
